<template>
    <div>
        <coupon-validator/>
        <support-auth-modal/>
        <modal ref="insertionModal" id="insertions" class="modal-wide" @hide="closeInsertion()">
            <div slot="title">
                {{ insertion ? insertion.fields['titulo'] : null }}
            </div>
            <div slot="body">
                <iframe class="insertion-iframe" v-if="insertion" :src="getUrl(insertion.id, 'corpo')" ref="insertion"/>
            </div>
        </modal>
        <KeviAlert type="success" v-for="link in links" :key="link.id">
            <div class="form-body">
                {{ link.fields['mensagem'] }}
                <a :href="link.fields['url']" target="_blank" class="btn btn-primary btn-sm">{{
                        link.fields['botao']
                    }}</a>
            </div>
        </KeviAlert>
    </div>
</template>
<style>
.form-body {
    display: flex;
    align-items: center;
    justify-content: space-between;
    width: 100%;
}

.insertion-iframe {
    width: 100%;
    height: 60vh;
    border: none;
}
</style>
<script>
import GlobalValidator from "../../coupons/global_validator";
import {getFormLinks, getSmartInsertionHtmlUrl, getSmartInsertions, init, hideInsertion} from "../../keviClientSDK";

export default {
    name: "layout-helpers",
    components: {
        "coupon-validator": GlobalValidator,
    },
    data() {
        return {
            searchForNewInsertions: true,
            links: [],
            insertions: [],
        };
    },
    props: {
        route: Array,
    },
    computed: {
        keviToken() {
            return this.$store.state.keviToken;
        },
        insertion() {
            if (this.insertions && this.insertions.length > 0) {
                return this.insertions[0];
            }
            return null;
        },
    },
    mounted() {
        window.setInterval(() => {
            this.loadInsertions()
            this.loadLinks()
        }, 1000*60*20) // 20 minutes
    },
    methods: {
        async loadInsertions() {
            if (this.keviToken && this.searchForNewInsertions) {
                this.insertions = await getSmartInsertions("popup_geral")
            }
        },
        async loadLinks() {
            if (this.keviToken) {
                await init(this.keviToken);
                this.links = await getSmartInsertions("links")
            }
        },
        getUrl(insertion, field) {
            return getSmartInsertionHtmlUrl(insertion, field);
        },
        closeInsertion() {
            if (this.insertion) {
                this.searchForNewInsertions = false;
                hideInsertion(this.insertion.id);
            }
        }
    },
    watch: {
        keviToken() {
            if (!this.keviToken) {
                return;
            }
            init(this.keviToken)
            this.loadLinks();
            this.loadInsertions();
        },
        insertion() {
            if (this.insertion) {
                this.$refs.insertionModal.open();
            }
        }
    }
};
</script>
